import * as React from "react";

function SvgEllipseIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
            <circle id="Ellipse_1" data-name="Ellipse 1" cx="5" cy="5" r="5" fill="#006EC8" />
        </svg>
    )
}
export default SvgEllipseIcon;


// WEBPACK FOOTER //
// ./src/iconComponents/iconEllipse.js